import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { studyFlowsActions } from 'features/studyFlows';

const useStudyFlows = () => {
  const dispatch = useDispatch();
  const getStudyFlow = useCallback(() => dispatch(studyFlowsActions.getStudyFlow()), [dispatch]);
  const createStudyFlow = useCallback(study_flow => dispatch(studyFlowsActions.createStudyFlow(study_flow)), [dispatch]);
  const updateStudyFlow = useCallback(study_flow => dispatch(studyFlowsActions.updateStudyFlow(study_flow)), [dispatch]);
  const deleteStudyFlow = useCallback(() => dispatch(studyFlowsActions.deleteStudyFlow()), [dispatch]);
  const clearLocalActiveStudyFlow = useCallback(() => dispatch(studyFlowsActions.clearLocalActiveStudyFlow()), [dispatch]);

  return {
    getStudyFlow,
    createStudyFlow,
    updateStudyFlow,
    deleteStudyFlow,
    clearLocalActiveStudyFlow
  };
};

export default useStudyFlows;